import * as clipboard from 'clipboard-polyfill';
import Content from 'js/components-v2/pages/UserDashboard/Content';
import Sidebar from 'js/components-v2/pages/UserDashboard/Sidebar';
import AppContent from 'js/components/AppContent';
import { AppButton } from 'js/new/Components/App';
import Pagination from 'js/new/Components/App/Pagination';
import { formatCurrency } from "js/services/Format";
import { makeRequest } from "js/services/Network";
import AppState from 'js/stores/AppState';
import AppUser from "js/stores/AppUser";
import UserDashboardPageState from 'js/stores/pages/UserDashboardPageState';
import React, { useState } from 'react';

const Earnings = () => {
  const page = UserDashboardPageState.create();
  const [earnings, setEarnings] = useState([])
  const [refLink, setRefLink] = useState('loading...');
  const [loading, setLoading] = useState(true);
  const [copied, setCopied] = useState(false);

  function copyLink() {
    clipboard.writeText(refLink);
    setCopied(true);

    setTimeout(() => setCopied(false), 5000);
  }

  React.useEffect(async () => {
    AppState.setCurrentPage('UserDashboardPage');
    await page.load();

    makeRequest('earnings-dashboard-data', '', '')
      .then(response => setEarnings(response.data))
      .catch(error => { });

    const userAlias = AppUser.login;
    const urlPart = window.location.host + "/seller"
    setRefLink(`${urlPart}/${userAlias}`)

    setLoading(false);
  }, []);

  const headers = [
    'Transaction ID',
    'Amount (N)',
    'Transaction type',
    'Order ID',
    'Date',
    'Status',
  ]

  return (
    <AppContent className='user-dashboard d-lg-flex align-items-stretch'>
      <Sidebar currentPage='UserEarningsPage' pageState={page} />

      <Content currentPage='UserEarningsPage' showCards={false}>
        <div className='bg-white tw-p-4 md:tw-px-8 tw-mt-3 tw-rounded-xl'>
          <h3 className="tw-mb-0">Earnings</h3>
        </div>

        <div className='tw-mt-3 tw-grid tw-grid-cols-2 md:tw-grid-cols-4 tw-gap-4 md:tw-gap-8'>
          {[
            'total_earnings',
            'total_pending_earnings',
            'total_referral_earnings',
            'total_refund',
          ].map((key) => {
            return (
              <div className='bg-white tw-p-4 tw-rounded-xl tw-gap-1 tw-flex tw-flex-col' key={key}>
                <p className='tw-capitalize tw-flex-1'>{key.replaceAll('_', ' ')}</p>
                <h3 className='tw-mb-0'>{loading ? '...' : (formatCurrency(earnings[key]) ?? 0)}</h3>
              </div>
            )
          })}
        </div>

        <div className="tw-mt-3 new-pod-ui bg-white tw-p-4 md:tw-p-8">
          {earnings['data']?.length > 0 &&
            <div>
              <div className="tw-overflow-x-auto">
                <table className="tw-table tw-table-auto tw-w-full">
                  <thead>
                    <tr>
                      {headers.map((head, i) => (
                        <th
                          key={i}
                          className={`${i === 0 ? 'tw-rounded-l-xl'
                            : i === headers.length - 1
                              ? 'tw-rounded-r-xl'
                              : ''}`}
                        >
                          {head}
                        </th>
                      ))}
                    </tr>
                  </thead>

                  <tbody>
                    {earnings['data']?.map(earning => {
                      const { transaction_id, transaction_type, order_id, amount, date, status } = earning;

                      return (
                        <tr key={transaction_id}>
                          <td>{transaction_id}</td>
                          <td>{formatCurrency(amount)}</td>
                          <td>{transaction_type}</td>
                          <td>{order_id}</td>
                          <td>{date}</td>
                          <td className='tw-capitalize'>{status?.replaceAll('_', ' ')}</td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>

              {/* <Pagination
                currentPage={1}
                totalPages={}
                onPageChange
               /> */}
            </div>
          }

          {earnings['data']?.length < 1 &&
            <div className='tw-text-center tw-gap-4 tw-py-6 tw-flex tw-flex-col tw-items-center'>
              <img
                src="/images/icons/empty-referral.svg"
                alt="earnings"
                className='tw-h-40 tw-w-auto'
              />

              {loading ?
                <p className='tw-py-12'>Loading earnings...</p> :
                <>
                  <h5>You have not earned anything from your store so far</h5>
                  <p>Share store link to buyers and put on you social media  accounts to start selling and earning.</p>
                  <AppButton onClick={copyLink}>{copied ? 'Copied' : 'Share store link'}</AppButton>
                </>
              }
            </div>
          }
        </div>
      </Content>
    </AppContent>
  );
}

export default Earnings;
